import React, { FC } from "react";
import { Table as MuiTable, TableProps } from "@mui/material";

const Table: FC<TableProps> = (props) => <MuiTable {...props} />;

export default Table;
